import { render, staticRenderFns } from "./main-header-accounting.vue?vue&type=template&id=2e3d1ad4&"
import script from "./main-header-accounting.ts?vue&type=script&lang=ts&"
export * from "./main-header-accounting.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports